import { render, staticRenderFns } from "./TextTemplate.yaml?vue&type=template&id=0600e1d1&component"
import script from "./TextTemplate.yaml?vue&type=script&lang=ts&component"
export * from "./TextTemplate.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports